<template>

    <!-- Registrations -->
    <b-container class="registrations">
        <b-card no-body>
            <b-card-header>
                <b-row>
                    <b-col>
                        <h5 class="text-success mb-2 mt-2"><i class="far fa-users mr-3"></i>{{conference.title}}</h5>
                    </b-col>
                    <b-col class="text-right">
<!--                        <b-button variant="success" size="sm"><i class="fas fa-file-excel mr-3"></i>Download CSV/Excel</b-button>-->
                    </b-col>
                </b-row>
            </b-card-header>

            <b-tabs card>
                <b-tab active>
                    <template v-slot:title><i class="far fa-exclamation-circle mr-2"></i>Incomplete
                        <b-badge variant="success">{{getRegByType(conference.registrations,'incomplete').length}}</b-badge>
                    </template>
                    <b-card-text>
                        <admin-registration-row :conference="conference" :registration="reg" v-for="reg in getRegByType(conference.registrations,'incomplete')"/>
                    </b-card-text>
                </b-tab>
                <b-tab>
                    <template v-slot:title><i class="far fa-check-circle mr-2"></i>Complete
                        <b-badge variant="success">{{getRegByType(conference.registrations,'complete').length}}</b-badge>
                    </template>
                    <b-card-text>
                        <admin-registration-row :conference="conference" :registration="reg" v-for="reg in getRegByType(conference.registrations,'complete')"/>
                    </b-card-text>
                </b-tab>
                <b-tab>
                    <template v-slot:title><i class="far fa-users mr-2"></i>All
                        <b-badge variant="success">{{getRegByType(conference.registrations,'all').length}}</b-badge>
                    </template>
                    <b-card-text>
                        <admin-registration-row :conference="conference" :registration="reg" v-for="reg in getRegByType(conference.registrations,'all')"/>
                    </b-card-text>
                </b-tab>
            </b-tabs>
        </b-card>

    </b-container>
</template>

<script>
    import {mapActions} from 'vuex';
    import AdminRegistrationRow from "../../../components/AdminRegistrationRow";

    export default {
        name: "conference-details",
        components: {AdminRegistrationRow},
        data() {
            return {
                conference: {
                    registrations: []
                }
            }
        },
        methods: {
            ...mapActions(['getAdminConfById', 'activateReg']),
            activate(reg) {
                reg.po_pending = 'false';
                this.activateReg(reg.code)
            },

            getRegByType(registrations, type) {
                return registrations.filter(reg => {
                    switch (type) {
                        case 'all':
                            return true;
                        case 'incomplete':
                            return (!reg.my247ed_id || !reg.cert_number);
                        case 'complete':
                            return (reg.my247ed_id && reg.cert_number);
                    }
                });
            }
        },
        mounted: function () {
            this.getAdminConfById(this.$route.params.confId).then(conf => {
                this.conference = conf;
            }, err => {
                this.conference = {};
                console.error(err);
            });
        }
    }
</script>

<style lang="scss" scoped>
    @import '~@/assets/scss/_variables.scss';

    a.link {
        color: $success;
    }

    .registrations {
        .badge {
            padding: 0.3rem 0.4rem 0.2rem;
            margin-left: 0.3rem;
        }

        .registration {
            &:nth-child(odd) {
                background: #f8f9fa;
            }
        }
    }

</style>

<style lang="scss">
    @import '~@/assets/scss/_variables.scss';

    .reg-nav {
        .nav-item {
            margin-right: 1.5rem;

            a {
                padding: 0.2rem;

                color: $success;
                font-size: 1.1rem;

                &.active {
                    border-bottom: 3px solid $success;
                }
            }
        }
    }

    .registrations {
        .nav-item {
            a {
                color: $success;
                font-size: 0.9rem;
            }
        }
    }

</style>
